<template>
  <div v-if="instance.activated === false">
    <b-modal v-model="showConfirmModal"
      title="Deseja ativar o usuário?"
      class="modal-primary"
      @ok="activate">

        Deseja realizar a ativação do usuário. Recomenda-se que o usuário ative a conta por meio do link enviado para o seu email. <a href="#" @click.stop.prevent="resend">Clique aqui para reenviar o email</a>.
    </b-modal>

    <span>
      <i class='fa fa-paper-plane-o'
        v-b-tooltip.hover
        title="Reenviar ativação"
        @click.stop.prevent="resend"></i>
    </span>

    <span>
      <i :class='icon' v-b-tooltip.hover :title="label" @click.stop.prevent="showConfirmModal = true"></i>
    </span>
  </div>
</template>

<script>
import Activations from '@/services/api/sys-activations'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Ativar'
    },

    icon: {
      type: String,
      default: 'fa fa-check-circle'
    }
  },

  data () {
    return {
      processing: false,
      showConfirmModal: false,
      activationHttp: null
    }
  },

  methods: {
    activate () {
      const self = this

      self.$Progress.start()
      self.processing = true
      self.showConfirmModal = false

      self.activationHttp.force(self.instance)
        .then((res) => {
          self.$Progress.finish()
          self.processing = false
          self.$toasted.success('Usuário ativado com sucesso')
          self.$emit('refresh')
        })
        .catch(() => {
          self.$Progress.fail()
          self.processing = false
          self.$toasted.info('Houve um erro ao tentar ativar o usuário')
        })
    },

    resend () {
      const self = this

      self.processing = true
      self.$Progress.start()
      self.showConfirmModal = false

      self.activationHttp.resend(self.instance)
        .then((res) => {
          self.$Progress.finish()
          self.processing = false
          self.$toasted.success('Um novo email foi enviado para o usuário')
          self.$emit('refresh')
        })
        .catch(() => {
          self.$Progress.fail()
          self.processing = false
          self.$toasted.info('Houve um erro ao tentar enviar o email para o usuário')
        })
    }
  },

  created () {
    this.activationHttp = Activations
  }
}
</script>

<style lang="sass" scoped>
i
  cursor: pointer
  margin-right: 8px
</style>



// WEBPACK FOOTER //
// src/components/ui/DatatableElements/ActivateUserElement.vue